import { render, staticRenderFns } from "./ClassSubjectDetail.vue?vue&type=template&id=b7cd5634"
import script from "./ClassSubjectDetail.vue?vue&type=script&lang=js"
export * from "./ClassSubjectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports